import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ApiService } from '../../core/services/api.service';
import { Feedback, FeedbackSubmit, PaginatedFeedback } from '../../models/feedback.model';

@Injectable({ providedIn: 'root' })
export class FeedbackService {
  private api = inject(ApiService);
  private http = inject(HttpClient);

  trackOpen(): Observable<{ message: string }> {
    return this.api.post('/api/feedback/track-open', {});
  }

  getScreenshotUploadUrl(
    filename: string,
    contentType: string,
  ): Observable<{ upload_url: string; object_name: string }> {
    return this.api.post('/api/feedback/screenshot-url', { filename, content_type: contentType });
  }

  uploadScreenshotToGcs(uploadUrl: string, file: File): Observable<object> {
    return this.http.put(uploadUrl, file, {
      headers: { 'Content-Type': file.type },
    });
  }

  submitFeedback(payload: FeedbackSubmit): Observable<{ data: Feedback; message: string }> {
    return this.api.post('/api/feedback', payload);
  }

  listFeedback(params: Record<string, string | number>): Observable<PaginatedFeedback> {
    return this.api.get('/api/feedback', params);
  }

  getFeedback(id: number): Observable<{ data: Feedback }> {
    return this.api.get(`/api/feedback/${id}`);
  }

  updateStatus(id: number, status: string): Observable<{ data: Feedback; message: string }> {
    return this.api.patch(`/api/feedback/${id}/status`, { status });
  }
}
